import { useProtectedImage } from '@/hooks/use-protected-image';
import { type ImgHTMLAttributes } from 'react';

type ProtectedImgProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  src?: string | null;
};

/**
 * Drop-in replacement for <img> that:
 *  - Fetches the signed proxy URL and swaps it for a blob: URL so the real
 *    URL is never visible in the DOM or DevTools Elements panel.
 *  - Disables right-click, drag, and iOS long-press save.
 */
export function ProtectedImg({ src, style, ...props }: ProtectedImgProps) {
  const { src: blobSrc } = useProtectedImage(src);

  return (
    <img
      {...props}
      src={blobSrc ?? undefined}
      draggable={false}
      onContextMenu={(e) => e.preventDefault()}
      style={{ WebkitTouchCallout: 'none', ...style } as React.CSSProperties}
    />
  );
}
